import React from 'react';
// import { Layout } from 'antd';
import { co, flexrow, flexcenter, mq, flexcolumn } from '../../styles/theme';
import Text from '../shared/Text';
// import FinautaLogo from '../logo/FinautaLogo';
// import LogoWhite from '../../static/images/svgs/finauta/logo-white.svg';
import PoliglotLink from '../PoliglotLink';
// import phone from '../../static/images/svgs/icons/phone.svg';
// import email from '../../static/images/svgs/icons/email.svg';

// import youtube from '../../static/images/svgs/icons/yt_white.svg';
// import facebook from '../../static/images/svgs/icons/facebook.svg';
import { space, layout } from 'styled-system';
// import GenericImage from '../images/GenericImage';
import { poliglotLink } from '../../classes/poliglotlink';
import styled, { css } from 'styled-components';
import Icon from '../shared/Icon';
import {callNumber, fancyPhoneNumber} from "../../constants/constants";

const StyledFooter = styled.div`
  ${flexcolumn}
  ${flexcenter}
  background-color: ${co.primaryColor};
  width: 100vw;
  height: fit-content;
`;

// const StyledLogo = styled(LogoWhite)`
//   height: 20px;
//   position: relative;
//   top: -10px;
//   left: -10px;
// `;

const Content = styled.div`
  ${flexrow}
  ${space}
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 20px;
  ${mq.md} {
    justify-content: space-around;
  }
  max-width: 800px;
`;

const Section = styled.div`
  width: 50%;
  margin-bottom: 20px;
  margin-top: 20px;
  ${mq.md} {
    width: 25%;
  }
  ${layout}
`;

const FinalSection = styled(Section)`
  ${flexrow}
  ${flexcenter}
  width: 100%;
  flex-wrap: wrap;
`;

// const StyledSocialIcon = styled(GenericImage)`
//   fill: white;
//   height: ${30 * (({ multiplier }) => (multiplier ? multiplier : 1))}px;
//   margin: 0px 10px;
//   ${mq.sm} {
//     height: ${40 * (({ multiplier }) => (multiplier ? multiplier : 1))}px;
//   }
// `;

// const Facebook = styled(facebook)`
//   fill: white;
//   width: 40px;
//   height: ${30 * 1.1}px;
//   ${mq.sm} {
//     height: ${40 * 1.1}px;
//   }
// `;
// const Youtube = styled(youtube)`
//   fill: white;
//   width: 60px;
//   margin-left: 20px;
//   height: ${30 * 0.9}px;
//   ${mq.sm} {
//     height: ${40 * 0.9}px;
//   }
// `;

const _generateStyledContactIcon = (icon) => {
  return styled(icon)`
    fill: white;
    width: 30px;
    height: 30px;
    margin-right: 10px;
    min-width: 30px;
  `;
};

// const Phone = _generateStyledContactIcon(phone);
// const Email = _generateStyledContactIcon(email);

const SocialIcons = styled.div`
  ${flexrow};
  justify-content: flex-start;
  align-items: center;
`;

const IconTextWrapper = styled.div`
  ${flexrow};
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 5px;
`;

const FooterLinkText = css`
  cursor: pointer;
  margin-bottom: 0px;
  font-size: 1rem;
  &:hover {
    text-decoration: underline;
  }
`;

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

const Footer = ({ light }) => (
  <StyledFooter>
    {light ? (
      <Content>
        (
        <FinalSection>
          <Text
            styles={FooterLinkText}
            marginTop={10}
            width={'100vw'}
            color="white"
            align="center"
            light
            marginless
          >
            Finauta {currentYear}
          </Text>
        </FinalSection>
        )
      </Content>
    ) : (
      <Content px={[20, 20, 50, 80, 80, 150, 250]}>
        <Section>
          <Text ttype="body" color="white" bold>
            Retiro
          </Text>
          <PoliglotLink to={new poliglotLink('https://www.finauta.com/pension-imss', false, false)}>
            <Text styles={FooterLinkText} color="white" light hovund>
              Guia de pensión
            </Text>
          </PoliglotLink>
          <PoliglotLink to={new poliglotLink('/retiro', false, true)}>
            <Text styles={FooterLinkText} color="white" light hovund>
              Calculadora de retiro
            </Text>
          </PoliglotLink>
          <PoliglotLink
            to={new poliglotLink('https://www.finauta.com/plan-de-pension', false, false)}
          >
            <Text styles={FooterLinkText} color="white" light hovund>
              Plan de pensión
            </Text>
          </PoliglotLink>
        </Section>
        <Section>
          <Text ttype="body" color="white" bold>
            Sobre nosotros
          </Text>
          {/* <PoliglotLink to={new poliglotLink('https://app.finauta.com/faq', false, false)}>
            <Text styles={FooterLinkText} color="white" light hovund>
              Preguntas frecuentes
            </Text>
          </PoliglotLink> */}
          <PoliglotLink to={new poliglotLink('/conocenos', false, true)}>
            <Text styles={FooterLinkText} color="white" light hovund>
              Conce al equipo
            </Text>
          </PoliglotLink>
        </Section>
        <Section>
          <Text ttype="body" color="white" bold>
            Contáctanos
          </Text>
          <IconTextWrapper>
            <Icon
              icon="phone"
              color={'white'}
              size={20}
              style={{ minWidth: '20px', margin: '10px' }}
            />
            <a href={`tel:${callNumber}`}>
              <Text styles={FooterLinkText} color="white" light hovund>
                {fancyPhoneNumber}
              </Text>
            </a>
          </IconTextWrapper>
          <IconTextWrapper>
            <Icon
              icon="email"
              color={'white'}
              size={20}
              style={{ minWidth: '20px', margin: '10px' }}
            />
            <a href="mailto:hola@finauta.com">
              <Text styles={FooterLinkText} color="white" light hovund>
                hola@finauta.com
              </Text>
            </a>
          </IconTextWrapper>
        </Section>
        <Section>
          <Text ttype="body" color="white" bold>
            Síguenos
          </Text>
          <SocialIcons>
            <PoliglotLink to={new poliglotLink('https://www.facebook.com/finautamx', true, false)}>
              <Icon icon="fbnew" color={'white'} size={30} style={{ margin: '10px' }} />
            </PoliglotLink>
            <PoliglotLink
              to={
                new poliglotLink(
                  'https://www.youtube.com/channel/UCoSbtqaWvQhIad6ZwTV2LkA',
                  true,
                  false,
                )
              }
            >
              <Icon icon="ytnew" color={'white'} size={45} style={{ margin: '10px' }} />
            </PoliglotLink>
          </SocialIcons>
        </Section>
        <FinalSection width={{ md: 1 }}>
          <PoliglotLink to={new poliglotLink('https://www.finauta.com/terminos', false, true)}>
            <Text
              styles={FooterLinkText}
              style={{ marginRight: '20px' }}
              color="white"
              light
              hovund
            >
              Términos y condiciones
            </Text>
          </PoliglotLink>
          <PoliglotLink to={new poliglotLink('https://www.finauta.com/aviso', false, true)}>
            <Text
              styles={FooterLinkText}
              marginLeft={{ _: '5px', xs: '15px', lg: '50px' }}
              color="white"
              align="center"
              hovund
              light
            >
              Aviso de privacidad
            </Text>
          </PoliglotLink>
          <Text
            styles={css`
              margin-top: 10px;
              width: 80vw;
              color: white;
              text-align: center;
            `}
          >
            Finauta {currentYear}
          </Text>
        </FinalSection>
      </Content>
    )}
  </StyledFooter>
);
export default Footer;
